import { MyScheduleListController } from './my_schedule_list_controller';

export class MyScheduleListComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-course-schedule/src/components/my_schedule_list/my_schedule_list.html';
  public controller: any = MyScheduleListController;
  public bindings: Record<string, '<'> = {
    term: '<'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-course-schedule/src/components/my_schedule_list/my_schedule_list_component.ts